"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_camelcase_1 = __importDefault(require("lodash.camelcase"));

function camelCase(value) {
  return lodash_camelcase_1.default(value);
}

exports.camelCase = camelCase;